import md5 from './md5.js'

// 接口加签
export function createSign(url, method, params) {
  url = url.replaceAll('/', '')
  let timestamp = new Date().getTime()
  let salt = 'yqa9wxoktd5mfh1hp4lm'
  let bodyStr = ''
  method = method.toUpperCase()
  if (method === 'POST' || method === 'PUT') {
    if (!params) {
      bodyStr = ''
    } else {
      bodyStr = JSON.stringify(params)
    }
  } else if (method === 'GET' || method === 'DELETE') {
    // const paramsAscii = Object.fromEntries(
    //   Object.entries(params).sort(([key1], [key2]) => localeCompareCustom(key1,key2))
    // )
    const paramsAscii = Object.entries(params).sort(function ([key1], [key2]) {
      return localeCompareCustom(key1,key2)
    }).reduce(function (acc, [key, value]) {
      if (value !== null && value !== undefined) {
        acc[key] = value;
      }
      return acc
    }, {})
    bodyStr = objToParams(paramsAscii)
  }
  let md5Result = md5.hex_md5(bodyStr)
  let signAll = url + md5Result + timestamp + salt
  let sortedStr = signAll.split('').sort().join('')
  // 5. 生成最终签名（首位固定为2）
  let result = generateFinishStr(sortedStr, '23')
  return {
    'S-Timestamp': timestamp, // 时间戳
    'S-Two-Sign': result, // 加签值
    'S-Request-Type': 'h5', // 请求类型
    'S-Exp-Content': '2.5.6' // 版本号
  }
}

/**
 * 自定义排序规则
 */
function localeCompareCustom(key1, key2) {
  const maxLength = Math.max(key1.length, key2.length);

  for (let i = 0; i < maxLength; i++) {
    if (key1[i] !== key2[i]) {
      // 检查第一个字符的大小写
      const firstChar1 = key1.charCodeAt(i) || 0;
      const firstChar2 = key2.charCodeAt(i) || 0;
      return firstChar1 - firstChar2;
    }
  }
}

// 将对象转换为参数字符串
function objToParams(obj) {
  let params = ''
  for (let key in obj) {
    console.log(key)
    if (params) {
      params += `&${key}=${obj[key]}`
    } else {
      params += `${key}=${obj[key]}`
    }
  }
  return params
}

// 生成一个字符串，根据给定字符串和固定的值
function generateFinishStr(str, fixedSeed) {
  let result = '1' // 首位固定为2
  const digits = fixedSeed.split('')
  const chars = str.split('')
  // 遍历字符串中的每个数字字符
  for (const digitChar of digits) {
    const divisor = digitChar.charCodeAt(0) - '0'.charCodeAt(0)
    // 跳过0和非法数字
    if (divisor <= 0) continue
    // 遍历输入字符串，按取模规则拼接字符
    for (let i = 0; i < chars.length; i++) {
      if (i % divisor === 0) {
        result += chars[i]
      }
    }
  }
  return result
}
